import {LazyLoadImage} from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/opacity.css";
import {Link} from "react-router-dom";
import DateHelper from "../../helpers/dateHelper";
import UtilsHelper from "../../helpers/utilsHelper.ts";
import {useEffect, useState} from "react";
import {IChannel} from "../../interfaces/IChannel.ts";
import {PlayIcon} from "@heroicons/react/24/solid";
import PlayButton from "../buttons/PlayButton.tsx";
import StringHelper from "../../helpers/stringHelper.ts";

interface Props {
    item: IChannel;
    className?: string;
}

const NewMovieCard = (props: Props) => {
    const [nowTimestamp, setNowTimestamp] = useState(0);
    const parseItemName = (name: string) => {
        name = StringHelper.removePolishDiacritics(name);
        name = name.replace(/\+/g, '');
        return name.replace(/\s+/g, "_");
    };

    useEffect(() => {
        const interval = setInterval(() => {
            setNowTimestamp(DateHelper.GetDateTimeNowAsUnixTimespan());
        }, 60000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className={`relative snap-start group flex flex-col rounded-t-lg overflow-hidden ${props.className}`}>
            <div className={'relative w-full aspect-[16/9]'}>
                <LazyLoadImage
                    alt=""
                    className="object-cover w-full rounded-lg"
                    effect="opacity"
                    src={`${import.meta.env.VITE_MIX_CHANNEL_THUMBNAILS_URL
                    }/${parseItemName(props.item.name)}/thumbnail.jpg?${nowTimestamp}`}
                />
                <div
                    className={"absolute top-0 left-0 pl-2 pt-2 pr-40 pb-14 bg-gradient-to-br from-neutral-900 via-50% via-transparent to-transparent"}>
                    <LazyLoadImage
                        alt=""
                        className="w-14 h-auto"
                        effect="opacity"
                        src={`${import.meta.env.VITE_MIX_CHANNEL_LOGO_URL}/${props.item.logo}`}
                    />
                </div>
                <div className={"absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-20 "}>
                    <div
                        className={"relative rounded-full md:opacity-0 bg-[#008DD2] group-hover:opacity-100 group-hover:hover:bg-[#007CC1] transition duration-500 w-12 h-12"}>
                        <PlayButton
                            channel={props.item}
                            withUnavailableModal={true}
                            loggedInElem={<PlayIcon className={"w-full h-full overflow-hidden p-2"}/>}
                            loggedOutElem={<PlayIcon className={"w-full h-full overflow-hidden p-2"}/>}
                        />
                    </div>
                </div>
            </div>
            <div className="pb-2 pt-1 rounded-lg font-poppins w-full">
                <div className="flex items-center justify-between space-x-1">
                    <div className="flex flex-col w-full overflow-hidden gap-.5">
                        <div className="text-neutral-400 truncate flex items-center space-x-1 text-sm tracking-wide">
                            {props.item.epgList[0]?.start_timestamp ?
                                <span className={"text-[#008DD2]"}>
                                    {DateHelper.GetHourAndMinuteFromUnixTimespanDate(
                                        props.item.epgList[0]?.start_timestamp
                                    )}
                                    -
                                    {DateHelper.GetHourAndMinuteFromUnixTimespanDate(
                                        props.item.epgList[0]?.stop_timestamp
                                    )}
                                </span>
                                :
                                <span>Brak danych</span>
                            }
                            <span>
                                - {props.item.name}
                            </span>
                        </div>
                        <div className="truncate text-neutral-200">
                            <span>
                                {props.item.epgList[0]?.name
                                    ? props.item.epgList[0].name
                                    : "Brak danych"}
                            </span>
                        </div>
                        <div className="truncate text-neutral-400 text-sm">
                            <span>
                                {props.item.epgList[0]?.category
                                    ? props.item.epgList[0].category
                                    : "Brak danych"}
                            </span>
                        </div>
                        <div
                            className="w-full flex-start flex h-0.5 overflow-hidden bg-neutral-600 mt-2">
                            <div
                                className={`flex h-full items-center justify-center overflow-hidden break-all bg-sky-500 text-white `}
                                style={{
                                    width: UtilsHelper.calcProgressBar(props.item.epgList[0]),
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <Link
                className={"absolute inset-0 z-10 hover:cursor-pointer"}
                to={`/kanaly-tv/${props.item.ch_id}`}
            ></Link>
        </div>
    );

    return (
        <div
            className={`snap-start relative flex flex-col group h-56 aspect-[14/10] md:h-80 flex-shrink-0 md:aspect-[11/9] overflow-hidden min-h-full`}>
            <div
                className="flex-grow flex-shrink-0 relative border border-transparent group-hover:border-[#008DD2] transition-colors overflow-hidden w-full aspect-video rounded-lg flex-shrink-1">
                <LazyLoadImage
                    alt=""
                    className="object-cover w-full h-full"
                    effect="opacity"
                    src={`${import.meta.env.VITE_MIX_CHANNEL_THUMBNAILS_URL
                    }/${parseItemName(props.item.name)}/thumbnail.jpg?${nowTimestamp}`}
                />
                {/*<div className={"absolute bottom-0 w-full h-14 bg-gradient-to-t from-neutral-900 to-transparent"}/>*/}
                {/*<div*/}
                {/*    className="absolute bottom-4 flex-start flex left-1/2 -translate-x-1/2 h-2 w-5/6 overflow-hidden bg-neutral-600 rounded-full">*/}
                {/*    <div*/}
                {/*        className={`flex h-full items-center justify-center overflow-hidden break-all bg-gradient-to-b from-sky-500 to-sky-900 text-white rounded-full`}*/}
                {/*        style={{*/}
                {/*            width: UtilsHelper.calcProgressBar(props.item.epgList[0]),*/}
                {/*        }}*/}
                {/*    />*/}
                {/*</div>*/}
                <div
                    className={"absolute top-0 left-0 pl-2 pt-2 pr-40 pb-14 bg-gradient-to-br from-neutral-900 via-50% via-transparent to-transparent"}>
                    <LazyLoadImage
                        alt=""
                        className="w-14 h-auto"
                        effect="opacity"
                        src={`${import.meta.env.VITE_MIX_CHANNEL_LOGO_URL}/${props.item.logo}`}
                    />
                </div>
                <div className={"absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-20 "}>
                    <div
                        className={"relative rounded-full md:opacity-0 bg-[#008DD2] group-hover:opacity-100 group-hover:hover:bg-[#007CC1] transition duration-500 w-12 h-12"}>
                        <PlayButton
                            channel={props.item}
                            withUnavailableModal={true}
                            loggedInElem={<PlayIcon className={"w-full h-full overflow-hidden p-2"}/>}
                            loggedOutElem={<PlayIcon className={"w-full h-full overflow-hidden p-2"}/>}
                        />
                    </div>
                </div>
            </div>

            <div className="py-2 rounded-lg font-poppins w-full">
                <div className="flex items-center justify-between space-x-1">
                    <div className="flex flex-col w-full overflow-hidden">
                        <div className="text-neutral-400 truncate flex items-center space-x-1 text-sm tracking-wide">
                            {props.item.epgList[0]?.start_timestamp ?
                                <span className={"text-[#008DD2]"}>
                                    {DateHelper.GetHourAndMinuteFromUnixTimespanDate(
                                        props.item.epgList[0]?.start_timestamp
                                    )}
                                    -
                                    {DateHelper.GetHourAndMinuteFromUnixTimespanDate(
                                        props.item.epgList[0]?.stop_timestamp
                                    )}
                                </span>
                                :
                                <span>Brak danych</span>
                            }
                            <span>
                                - {props.item.name}
                            </span>
                        </div>
                        <div className="truncate text-neutral-200">
                            <span>
                                {props.item.epgList[0]?.name
                                    ? props.item.epgList[0].name
                                    : "Brak danych"}
                            </span>
                        </div>
                        <div className="truncate text-neutral-400 text-sm">
                            <span>
                                {props.item.epgList[0]?.category
                                    ? props.item.epgList[0].category
                                    : "Brak danych"}
                            </span>
                        </div>
                        <div
                            className="w-full flex-start flex h-0.5 overflow-hidden bg-neutral-600 mt-2">
                            <div
                                className={`flex h-full items-center justify-center overflow-hidden break-all bg-sky-500 text-white `}
                                style={{
                                    width: UtilsHelper.calcProgressBar(props.item.epgList[0]),
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <Link
                className={"absolute inset-0 z-10 hover:cursor-pointer"}
                to={`/kanaly-tv/${props.item.ch_id}`}
            ></Link>
        </div>
    );
};
export default NewMovieCard;
